module.exports = __webpack_public_path__ + "img/icon_e2.e7259bf5.png";